export default "__VITE_ASSET__DcucaTkO__"